import React, { useState, useEffect } from 'react';
import { Container, Table, Button, Modal, Form, Spinner, Image, Toast } from 'react-bootstrap';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';
import { getAdvertisements, deleteAdvertisement, addAdvertisement, updateAdvertisement } from '../../services/advertisementService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AdvertisementList = () => {
  const [advertisements, setAdvertisements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAdvertisement, setSelectedAdvertisement] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [newAdvertisement, setNewAdvertisement] = useState({
    header: '',
    detail: '',
    date: '',
    picture: null,
    file: null
  });
  const [editAdvertisement, setEditAdvertisement] = useState({
    guid: '',
    header: '',
    detail: '',
    date: '',
    picture: null,
    file: null,
    pictureBase64: '',
    fileBase64: '',
    pictureUrl: '',
    fileUrl: ''
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 50,
    totalCount: 0,
    pageCount: 0
  });

  useEffect(() => {
    fetchAdvertisements();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  const fetchAdvertisements = async () => {
    try {
      setLoading(true);
      const params = {
        pageNum: pagination.currentPage,
        pageSize: pagination.pageSize,
        searchTerm: "",
        sortBy: "",
        startDate: "2024-03-20T22:10:19.398Z",
        endDate: "2030-03-20T22:10:19.398Z"
      };
      
      const response = await getAdvertisements(params);
      console.log('Advertisements response:', response);
      
      if (response?.items) {
        setAdvertisements(response.items);
        setPagination({
          currentPage: response.currentPage,
          pageSize: response.pageSize,
          totalCount: response.totalCount,
          pageCount: response.pageCount
        });
        setError(null);
      } else {
        setError('İlanlar yüklenirken bir hata oluştu.');
        setAdvertisements([]);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setError('İlanlar yüklenirken bir hata oluştu.');
      setAdvertisements([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedAdvertisement) return;
    
    try {
      setLoading(true);
      const response = await deleteAdvertisement(selectedAdvertisement.guid);
      console.log('Delete response:', response);
      
      if (response?.isSuccess) {
        setError(null);
        setShowDeleteModal(false); // Önce modalı kapat
        setSelectedAdvertisement(null); // Sonra seçili ilanı temizle
        await fetchAdvertisements(); // En son yeni listeyi getir
      } else {
        setError('İlan silinirken bir hata oluştu.');
      }
    } catch (err) {
      console.error('Delete error:', err);
      setError('İlan silinirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleEdit = (advertisement) => {
    setSelectedAdvertisement(advertisement);
    setEditAdvertisement({
      guid: advertisement.guid,
      header: advertisement.header,
      detail: advertisement.detail,
      date: advertisement.date,
      picture: null,
      file: null,
      pictureBase64: '',
      fileBase64: '',
      pictureUrl: advertisement.pictureUrl || '',
      fileUrl: advertisement.fileUrl || ''
    });
    setShowEditModal(true);
  };
  
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      // Mevcut ilan verilerini kullanarak güncelleme verilerini oluştur
      const updateData = { 
        ...editAdvertisement,
        date: editAdvertisement.date ? new Date(editAdvertisement.date).toISOString() : new Date().toISOString()
      };
      
      // Eğer yeni bir resim seçilmemişse ve mevcut resim varsa, mevcut resmi kullan
      if (!updateData.picture && selectedAdvertisement?.pictureUrl) {
        // Mevcut resim bilgisini koru
        updateData.existingPictureUrl = selectedAdvertisement.pictureUrl;
        console.log('Mevcut resim korunuyor:', selectedAdvertisement.pictureUrl);
      } else if (!updateData.picture && !selectedAdvertisement?.pictureUrl) {
        // Eğer resim seçilmemiş ve mevcut resim de yoksa, boş gönder
        updateData.picture = null;
        updateData.pictureBase64 = '';
        updateData.existingPictureUrl = '';
        console.log('Resim seçilmedi ve mevcut resim yok, boş gönderiliyor');
      }
      
      // Eğer yeni bir dosya seçilmemişse ve mevcut dosya varsa, mevcut dosyayı kullan
      if (!updateData.file && selectedAdvertisement?.fileUrl) {
        // Mevcut dosya bilgisini koru
        updateData.existingFileUrl = selectedAdvertisement.fileUrl;
        console.log('Mevcut dosya korunuyor:', selectedAdvertisement.fileUrl);
      } else if (!updateData.file && !selectedAdvertisement?.fileUrl) {
        // Eğer dosya seçilmemiş ve mevcut dosya da yoksa, boş gönder
        updateData.file = null;
        updateData.fileBase64 = '';
        updateData.existingFileUrl = '';
        console.log('Dosya seçilmedi ve mevcut dosya yok, boş gönderiliyor');
      }
      
      console.log('Güncelleme için gönderilen veri:', {
        ...updateData,
        picture: updateData.picture ? 'Yeni resim seçildi' : 'Resim seçilmedi',
        file: updateData.file ? 'Yeni dosya seçildi' : 'Dosya seçilmedi',
        existingPictureUrl: updateData.existingPictureUrl || 'Yok',
        existingFileUrl: updateData.existingFileUrl || 'Yok'
      });
      
      const response = await updateAdvertisement(updateData);
      
      // Log the full response structure to debug
      console.log('Update response structure:', response);
      
      // Check different possible success response formats
      if (response?.isSuccess || response?.data?.isSuccess || response === true || response?.data === true) {
        setToastMessage('İlan başarıyla güncellendi!');
        setToastVariant('success');
        setShowToast(true);
        await fetchAdvertisements();
        setShowEditModal(false);
        setError(null);
      } else {
        const errorMessage = response?.resultMessage || response?.data?.resultMessage || 'İlan güncellenirken bir hata oluştu.';
        setToastMessage(errorMessage);
        setToastVariant('danger');
        setShowToast(true);
        setError(errorMessage);
      }
    } catch (err) {
      console.error('Update error:', err);
      setError('İlan güncellenirken bir hata oluştu.');
      setToastMessage('İlan güncellenirken bir hata oluştu.');
      setToastVariant('danger');
      setShowToast(true);
    } finally {
      setLoading(false);
    }
  };

  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // Keep the full data URL including the MIME type prefix
        // This ensures the file type is preserved when downloaded
        resolve(reader.result);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      const data = {
        date: newAdvertisement.date ? new Date(newAdvertisement.date).toISOString() : new Date().toISOString(),
        header: newAdvertisement.header,
        detail: newAdvertisement.detail,
        picture: newAdvertisement.picture,
        pictureUrl: newAdvertisement.picture?.name || '',
        file: newAdvertisement.file,
        fileUrl: newAdvertisement.file?.name || ''
      };

      const response = await addAdvertisement(data);
      console.log('Add response:', response);
      
      if (response?.isSuccess) {
        await fetchAdvertisements();
        setShowAddModal(false);
        setNewAdvertisement({ header: '', detail: '', date: '', picture: null, file: null });
        setError(null); // Başarılı olduğunda error'u temizle
      } else {
        setError('İlan eklenirken bir hata oluştu.');
      }
    } catch (err) {
      console.error('Add error:', err);
      setError('İlan eklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAdvertisement(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditAdvertisement(prev => ({
      ...prev,
      [name]: value
    }));
  };

  if (loading) {
    return (
      <Container className="mt-4 d-flex justify-content-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>İlanlar</h2>
        <Button variant="primary" onClick={() => setShowAddModal(true)}>
          Yeni İlan Ekle
        </Button>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Tarih</th>
            <th>Başlık</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {advertisements && Object.values(advertisements).map((advertisement) => (
            <tr key={advertisement.guid}>
              <td>{formatDate(advertisement.date)}</td>
              <td>{advertisement.header}</td>
              <td>
                <Button
                  variant="info"
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    setSelectedAdvertisement(advertisement);
                    setShowDetailModal(true);
                  }}
                >
                  <FaEye /> Detay
                </Button>
                <Button
                  variant="warning"
                  size="sm"
                  className="me-2"
                  onClick={() => handleEdit(advertisement)}
                >
                  <FaEdit /> Düzenle
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => {
                    setSelectedAdvertisement(advertisement);
                    setShowDeleteModal(true);
                  }}
                >
                  <FaTrash /> Sil
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Detail Modal */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>İlan Detayı</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAdvertisement && (
            <>
              <h4>{selectedAdvertisement.header}</h4>
              <p className="text-muted">
                {formatDate(selectedAdvertisement.date)}
              </p>
              
              {selectedAdvertisement.pictureUrl && (
                <div className="text-center mb-3">
                  <Image 
                    src={selectedAdvertisement.pictureUrl} 
                    alt={selectedAdvertisement.header}
                    fluid 
                  />
                </div>
              )}
              
              <div style={{ whiteSpace: 'pre-wrap' }}>
                {selectedAdvertisement.detail}
              </div>
              
              {selectedAdvertisement.fileUrl && (
                <div className="mt-3">
                  <a 
                    href={selectedAdvertisement.fileUrl} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="btn btn-outline-primary"
                  >
                    Dosyayı İndir
                  </a>
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
            Kapat
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal show={showDeleteModal && selectedAdvertisement} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>İlan Sil</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bu ilanı silmek istediğinizden emin misiniz?
          <br />
          <strong>{selectedAdvertisement?.header}</strong>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            setShowDeleteModal(false);
            setSelectedAdvertisement(null);
          }}>
            İptal
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Sil
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)} size="xl" fullscreen="lg-down">
        <Modal.Header closeButton>
          <Modal.Title>Yeni İlan Ekle</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: 'auto', maxHeight: '90vh' }}>
          <Form onSubmit={handleAdd}>
            <Form.Group className="mb-3">
              <Form.Label>Başlık</Form.Label>
              <Form.Control
                type="text"
                name="header"
                value={newAdvertisement.header}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Tarih</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={newAdvertisement.date}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-4" style={{ marginBottom: '2rem' }}>
              <Form.Label>Detay</Form.Label>
              <div style={{ width: '100%', marginBottom: '60px' }}>
                <ReactQuill
                  theme="snow"
                  value={newAdvertisement.detail || ''}
                  onChange={(value) => setNewAdvertisement(prev => ({ ...prev, detail: value }))}
                  modules={{
                    toolbar: [
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                      [{ 'font': [] }],
                      [{ 'size': ['small', false, 'large', 'huge'] }],
                      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                      [{ 'color': [] }, { 'background': [] }],
                      [{ 'script': 'sub'}, { 'script': 'super' }],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                      [{ 'align': [] }],
                      ['link', 'image', 'video'],
                      ['clean'],
                      ['code-block']
                    ]
                  }}
                  style={{ 
                    height: '400px',
                    backgroundColor: '#fff'
                  }}
                  formats={[
                    'header', 'font', 'size',
                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                    'color', 'background',
                    'script',
                    'list', 'bullet', 'indent',
                    'align',
                    'link', 'image', 'video',
                    'code-block'
                  ]}
                />
              </div>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Resim</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setNewAdvertisement(prev => ({ ...prev, picture: e.target.files[0] }))}
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Dosya</Form.Label>
              <Form.Control
                type="file"
                onChange={(e) => setNewAdvertisement(prev => ({ ...prev, file: e.target.files[0] }))}
              />
            </Form.Group>
            
            <div className="d-flex justify-content-end">
              <Button variant="secondary" className="me-2" onClick={() => setShowAddModal(false)}>
                İptal
              </Button>
              <Button variant="primary" type="submit">
                Ekle
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="xl" fullscreen="lg-down">
        <Modal.Header closeButton>
          <Modal.Title>İlan Düzenle</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflowY: 'auto', maxHeight: '90vh' }}>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Başlık</Form.Label>
              <Form.Control
                type="text"
                name="header"
                value={editAdvertisement.header}
                onChange={handleEditInputChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Tarih</Form.Label>
              <Form.Control
                type="date"
                name="date"
                value={editAdvertisement.date ? (() => {
                  try {
                    const date = new Date(editAdvertisement.date);
                    return isNaN(date.getTime()) ? '' : date.toISOString().split('T')[0];
                  } catch {
                    return '';
                  }
                })() : ''}
                onChange={handleEditInputChange}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-4" style={{ marginBottom: '2rem' }}>
              <Form.Label>Detay</Form.Label>
              <div style={{ width: '100%', marginBottom: '60px' }}>
                <ReactQuill
                  theme="snow"
                  value={editAdvertisement.detail || ''}
                  onChange={(value) => setEditAdvertisement(prev => ({ ...prev, detail: value }))}
                  modules={{
                    toolbar: [
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                      [{ 'font': [] }],
                      [{ 'size': ['small', false, 'large', 'huge'] }],
                      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                      [{ 'color': [] }, { 'background': [] }],
                      [{ 'script': 'sub'}, { 'script': 'super' }],
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                      [{ 'align': [] }],
                      ['link', 'image', 'video'],
                      ['clean'],
                      ['code-block']
                    ]
                  }}
                  style={{ 
                    height: '400px',
                    backgroundColor: '#fff'
                  }}
                  formats={[
                    'header', 'font', 'size',
                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                    'color', 'background',
                    'script',
                    'list', 'bullet', 'indent',
                    'align',
                    'link', 'image', 'video',
                    'code-block'
                  ]}
                />
              </div>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Resim</Form.Label>
              {selectedAdvertisement?.pictureUrl && (
                <div className="mb-2">
                  <small>Mevcut resim: {selectedAdvertisement.pictureUrl}</small>
                  <br />
                  <Image 
                    src={selectedAdvertisement.pictureUrl} 
                    alt="Mevcut resim" 
                    style={{ maxWidth: '100px', maxHeight: '100px' }} 
                    className="mt-1"
                  />
                </div>
              )}
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => setEditAdvertisement(prev => ({ ...prev, picture: e.target.files[0] || null }))}
              />
              <small className="text-muted">Yeni resim seçmezseniz mevcut resim korunacaktır.</small>
            </Form.Group>
            
            <Form.Group className="mb-3">
              <Form.Label>Dosya</Form.Label>
              {selectedAdvertisement?.fileUrl && (
                <div className="mb-2">
                  <small>Mevcut dosya: {selectedAdvertisement.fileUrl}</small>
                </div>
              )}
              <Form.Control
                type="file"
                onChange={(e) => setEditAdvertisement(prev => ({ ...prev, file: e.target.files[0] || null }))}
              />
              <small className="text-muted">Yeni dosya seçmezseniz mevcut dosya korunacaktır.</small>
            </Form.Group>
            
            <div className="d-flex justify-content-end">
              <Button variant="secondary" className="me-2" onClick={() => setShowEditModal(false)}>
                İptal
              </Button>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                    {' '}Güncelleniyor...
                  </>
                ) : (
                  'Güncelle'
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Kapat
          </Button>
      </Modal.Footer>
    </Modal>

    {/* Delete Modal */}
    <Modal show={showDeleteModal && selectedAdvertisement} onHide={() => setShowDeleteModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>İlan Sil</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Bu ilanı silmek istediğinizden emin misiniz?
        <br />
        <strong>{selectedAdvertisement?.header}</strong>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => {
          setShowDeleteModal(false);
          setSelectedAdvertisement(null);
        }}>
          İptal
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          Sil
        </Button>
      </Modal.Footer>
    </Modal>

    {/* Duplicate modals removed - using the ones above */}

    {/* Toast Notification */}
    <Toast 
      show={showToast} 
      onClose={() => setShowToast(false)} 
      delay={3000} 
      autohide 
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 9999
      }}
      bg={toastVariant}
    >
      <Toast.Header closeButton={true}>
        <strong className="me-auto">{toastVariant === 'success' ? 'Başarılı' : 'Hata'}</strong>
      </Toast.Header>
      <Toast.Body className={toastVariant === 'success' ? 'text-white' : ''}>{toastMessage}</Toast.Body>
    </Toast>
  </Container>
);
}
export default AdvertisementList;

